<div
  class="__grid"
  [class.__grid--start]="items?.length >= 4">
  <div *ngFor="let item of items; trackBy: trackBy;">
    <button
      class="__item"
      [class.is-active]="value === item.name"
      (click)="value = item.name; versionSelected.emit(item.name)"
      type="button">
      <h3 class="__item_version">{{ item.versionNumber }}</h3>
      <span class="__item_exact-version">{{ item.exactVersionNumber }}</span>
    </button>
  </div>
</div>
